import React from 'react';

const DeleteIcon = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>

            <path
                d='M7 8L7.91732 18.0905C7.96415 18.6056 8.39601 19 8.91321 19H15.0868C15.604 19 16.0359 18.6056 16.0827
                18.0905L17 8M5 8H12H19M9 8V6C9 5.44772 9.44772 5 10 5H14C14.5523 5 15 5.44772 15 6V8M12 12V15'
                strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
            />
        </svg>
    );
};

export default DeleteIcon;
